<div class="faq-container">
    <div class="header">
        <p class="faq-title">Upload FAQs</p>
        <mat-icon class="mat-icon" style="cursor: pointer;" (click)="closePopUp()">close</mat-icon>
    </div>
    <p class="faq-content">Uploading will replace the existing FAQs. Are you sure?</p>
    <div class="button">
        <button id="keep-button" (click)="closePopUp()">Cancel</button>
        <button id="delete-button" style="background-color: #386AF6;" (click)="continueUpload()">Continue</button>
    </div>
</div>
